import { flashNews, type FlashItem } from '@/mocks/homeData';

const toneMap: Record<FlashItem['tagTone'], { pill: string; dot: string }> = {
  primary: { pill: 'bg-primary-100 text-primary-700', dot: 'bg-primary-500' },
  accent: { pill: 'bg-accent-100 text-accent-900', dot: 'bg-accent-500' },
  secondary: { pill: 'bg-secondary-100 text-secondary-900', dot: 'bg-secondary-500' },
};

const nightRhythm = [
  { time: '18:00', label: '片单出炉', icon: 'ri-file-list-3-line' },
  { time: '20:00', label: '正片上线', icon: 'ri-play-circle-line' },
  { time: '22:30', label: '热搜发酵', icon: 'ri-fire-line' },
];

export default function Flash() {
  return (
    <section id="flash" className="scroll-mt-20 bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <div className="flex items-end justify-between gap-4">
              <div>
                <span className="text-sm font-semibold tracking-widest text-primary-600">实时资讯流</span>
                <h2 className="mt-2 font-heading text-3xl font-black text-foreground-950 md:text-4xl">
                  最新快讯<span className="text-primary-600">滚动更新</span>
                </h2>
              </div>
              <span className="hidden items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1.5 text-xs text-primary-700 sm:inline-flex">
                <span className="h-1.5 w-1.5 rounded-full bg-primary-500" />
                24h 持续更新
              </span>
            </div>

            <div className="mt-8 space-y-0">
              {flashNews.map((item) => {
                const tone = toneMap[item.tagTone];
                return (
                  <article key={item.id} className="relative flex gap-4 pb-7 last:pb-0 md:gap-6">
                    {/* timeline gutter */}
                    <div className="flex flex-col items-center pt-1.5">
                      <span className={`h-3 w-3 shrink-0 rounded-full ${tone.dot} ring-4 ring-background-200/70`} />
                      {item.id !== flashNews.length && (
                        <span className="mt-1 w-px flex-1 bg-background-200" />
                      )}
                    </div>

                    <div className="flex-1 rounded-xl border border-background-200 bg-background-100/50 p-4 transition hover:border-primary-200 hover:bg-background-100 md:p-5">
                      <div className="flex flex-wrap items-center gap-2 text-xs">
                        <span className={`rounded-full px-2.5 py-1 font-medium ${tone.pill}`}>{item.tag}</span>
                        <span className="inline-flex items-center gap-1 text-foreground-400">
                          <i className="ri-time-line" />
                          {item.time}
                        </span>
                        <span className="hidden text-foreground-400 sm:inline">{item.date}</span>
                      </div>
                      <h3 className="mt-2.5 font-heading text-base font-bold text-foreground-900 md:text-lg">{item.title}</h3>
                      <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
                    </div>
                  </article>
                );
              })}
            </div>
          </div>

          {/* right sidebar */}
          <aside className="flex flex-col gap-5 lg:sticky lg:top-24 lg:self-start">
            <div className="rounded-2xl border border-background-200 bg-background-100/70 p-6">
              <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
                <i className="ri-moon-fill text-accent-500" />
                今晚蹲守节奏
              </h3>
              <div className="mt-4 space-y-3">
                {nightRhythm.map((r, i) => (
                  <div key={r.time} className="flex items-center gap-3 rounded-lg bg-background-50 px-4 py-3">
                    <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                      <i className={r.icon} />
                    </span>
                    <span className="flex-1 font-medium text-foreground-800">{r.label}</span>
                    <span className="font-latin text-lg text-accent-600">{r.time}</span>
                    {i !== nightRhythm.length - 1 && null}
                  </div>
                ))}
              </div>
              <p className="mt-3 text-xs text-foreground-500">热度集中在 20:00–23:00，别错过正片首发的名场面。</p>
            </div>

            <a
              href="#schedule"
              onClick={(e) => { e.preventDefault(); document.getElementById('schedule')?.scrollIntoView({ behavior: 'smooth' }); }}
              className="group flex items-center gap-3 rounded-2xl bg-foreground-950 p-6 text-background-50 transition hover:bg-foreground-900"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary-500">
                <i className="ri-calendar-todo-line text-xl" />
              </span>
              <span className="flex-1">
                <span className="block font-heading font-bold">下一步蹲哪个点？</span>
                <span className="block text-sm text-background-100/70">回到蹲瓜时间表看看节点顺序</span>
              </span>
              <i className="ri-arrow-right-s-line text-2xl text-background-100 transition group-hover:translate-x-1" />
            </a>
          </aside>
        </div>
      </div>
    </section>
  );
}